
import React from "react";
import { ClientSubscription, Client } from "@/models/Client";
import SessionCard from "./SessionCard";
import { useTranslation } from "react-i18next";

interface SessionsModalContentProps {
  client: Client;
  activeSubscriptions: ClientSubscription[];
  sessionData: {
    [key: string]: number;
  };
  onSessionChange: (subscriptionId: string, value: string) => void;
  getWorkoutTypeName: (workoutTypeId: string) => string;
}

const SessionsModalContent: React.FC<SessionsModalContentProps> = ({
  client,
  activeSubscriptions,
  sessionData,
  onSessionChange,
  getWorkoutTypeName
}) => {
  const { t } = useTranslation();

  if (activeSubscriptions.length === 0) {
    return <div className="text-center py-8 text-muted-foreground">
        {t('clients.noActiveSubscriptions')}
      </div>;
  }

  return <div className="space-y-4">
      {/* Session cards for each subscription */}
      <div className="space-y-4">
        <h3 className="text-sm font-medium text-muted-foreground">
          {t('clients.manageSessions')}
        </h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {activeSubscriptions.map(subscription => <SessionCard key={subscription.id} subscription={subscription} sessionCount={sessionData[subscription.id]} onSessionChange={onSessionChange} getWorkoutTypeName={getWorkoutTypeName} />)}
        </div>
      </div>
    </div>;
};

export default SessionsModalContent;
